
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import WebsiteRepositoryInterface, { Website } from "@/services/Website/interfaces";
import { DatabaseInterface, DatabaseRepositoryInterface } from "@/services/Database/interfaces";
import { ServerInterface } from "@/services/Server/Interfaces";
import { RedisCacheStatusEnum } from "@/services/RedisCache/interfaces/redis-cache.interface";

@Component({
  computed: {
    RedisCacheStatusEnum() {
      return RedisCacheStatusEnum;
    },
  },
  mixins: [
    Themeable,
  ],
  inject: [
    'websiteRepository',
    'databaseRepository',
    'serverRepository',
  ],
})
export default class RedisCacheManagementDialog extends Vue {
  public visible: boolean = true;
  @Prop() public data: {

    owner?: string,
  };


  public async created(): Promise<void> {
  }

  public toggle(enable: boolean): void {
    this.$emit('rc_toggle', enable);
    this.$emit('close');
  }

  public syncStatus() {
    this.$emit('rc_sync', "");
    this.$emit('close');
  }

  public destroyComponent(): void {
    this.$emit('close');
  }
}
